<template>
    <form-layout
        :checker="checker"
        :transaction="transaction"
        :payload="payload"
        :error="error"
        @proceed="initTransaction"
    >
        <div class="w-10/12 mx-auto py-10">
            <div
                @click="() => $router.push('/bills')"
                class="
                flex items-center  pb-5 font-medium text-lg text-smoke-200 cursor-pointer 
            "
            >
                <p class="pt-1">
                    Go Back
                </p>
                <svg
                    width="14"
                    height="12"
                    viewBox="0 0 14 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="ml-2"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M12.8572 5.14281H2.68716L5.80118 1.40565C6.10461 1.04221 6.0549 0.501354 5.69147 0.198781C5.32718 -0.10465 4.78717 -0.0549354 4.4846 0.308495L0.198858 5.45139C0.16543 5.49167 0.148287 5.53882 0.123429 5.58339C0.102858 5.61939 0.0780005 5.65024 0.0625718 5.68967C0.0240002 5.78825 0.000857148 5.89196 0.000857148 5.99653C0.000857148 5.99739 0 5.9991 0 5.99996C0 6.00082 0.000857148 6.00253 0.000857148 6.00339C0.000857148 6.10796 0.0240002 6.21168 0.0625718 6.31025C0.0780005 6.34968 0.102858 6.38053 0.123429 6.41653C0.148287 6.46111 0.16543 6.50825 0.198858 6.54854L4.4846 11.6914C4.65432 11.8946 4.89775 12 5.14289 12C5.33661 12 5.53118 11.9349 5.69147 11.8011C6.0549 11.4986 6.10461 10.9577 5.80118 10.5943L2.68716 6.85711H12.8572C13.3304 6.85711 13.7144 6.47311 13.7144 5.99996C13.7144 5.52681 13.3304 5.14281 12.8572 5.14281Z"
                        fill="#D3DCE6"
                    />
                </svg>
            </div>
            <div class="flex mb-10">
                <p class="text-smoke-200 font-medium text-lg">Paycode</p>
            </div>
            <div class="flex justify-between items-end mb-10 md:mb-10">
                <div class="">
                    <h2 class="text-4xl text-purple-dark font-medium">Generate Paycode</h2>
                </div>
                <biller-country-selector />
            </div>

            <paycode-form @proceed="setTrans" />
        </div>
    </form-layout>
</template>

<script>
import { formatAmount } from '@/util/formatAmount'
import PaycodeForm from '@/components/forms/Paycode'
import { initialise } from '@/api/paycode'
import { mapActions } from 'vuex'
import BillerCountrySelector from '@/components/ui/BillerCountrySelector'
export default {
    metaInfo: {
        title: 'Paycode',
    },
    data() {
        return {
            transaction: {},
            payload: {},
            error: false,
            checker: false,
        }
    },
    components: {
        PaycodeForm,
        BillerCountrySelector,
    },

    methods: {
        setTrans(val) {
            this.transaction = val
            this.checker = !this.checker
        },

        ...mapActions('Message', {
            setMessageType: 'SET_MESSAGE_TYPE',
            setMessage: 'SET_MESSAGE',
        }),

        initTransaction(trans) {
            initialise(trans)
                .then((data) => {
                    this.payload = data.data.data
                    this.error = false
                    this.setNotification({
                        type: 1,
                        title: 'Your transaction has been initialized',
                        body: `You have requested for a paycode through <b>${trans.withdrawal_channel}</b> for value <b>₦${trans.amount}</b>`,
                        created_at: new Date(),
                        seen: false,
                    })
                })
                .catch(() => {
                    this.error = true
                    setTimeout(() => {
                        this.error = false
                    }, 500)
                    this.setMessageType(false)
                    this.setMessage(
                        'Sorry an error occurred while trying to process your transaction. Please try again later'
                    )
                })
        },
    },

    watch: {
        input: function(newValue) {
            let val = newValue
                .toString()
                .split(',')
                .join('')
            this.input = formatAmount(val)
        },
    },
}
</script>

<style lang="scss">
.modal-width {
    width: 400px;
}

.text-double {
    font-size: 2rem;
}
</style>
